exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-margin[data-v-057d7647] {\n  margin: auto;\n}\n.grey[data-v-057d7647] {\n  color: #9ba1ab;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-057d7647","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/upgrade-plan/UpgradePlanCard.vue
// module id = 1456
// module chunks = 0